<template>
    <AppLayout title="Envíos">
        <div class="retiros bg-white">
            <div class="">
                <Toast />

                <div
                    class="flex flex-col lg:flex-row lg:justify-between lg:items-center pt-4 mb-4 mr-6"
                >
                    <Breadcrumb
                        name="Envíos"
                        routeName="envios"
                        page="Todos los envíos"
                    />
                    <div class="flex ml-4">
                        <Link href="/envios/crear">
                            <Button>
                                <div class="flex items-center space-x-2">
                                    <Icon size="15">
                                        <Plus />
                                    </Icon>
                                    <span>Crear envío</span>
                                </div>
                            </Button>
                        </Link>
                        <Button
                            @click="openExportDialog"
                            v-tooltip.top="'Exportar'"
                        >
                            <Icon size="15">
                                <FileExport />
                            </Icon>
                        </Button>
                    </div>
                </div>

                <!-- filters -->

                <XyzTransition appear xyz="fade" :duration="2000">
                    <div class="mb-4 flex justify-between items-center">
                        <CustomFilter
                            :filtersData="filtersData"
                            :proveedores="proveedores"
                            :clientes="clientes"
                            :loading="loading"
                            @getFilteredShipment="getFilteredShipment"
                            @clearFilters="clearFilters"
                        />
                    </div>
                </XyzTransition>

                <XyzTransition appear xyz="fade" :duration="3000">
                    <DataTable
                        :value="shipping"
                        responsiveLayout="scroll"
                        :rowHover="true"
                        dataKey="id"
                        v-model:selection="selectedShipping"
                        :style="{ fontSize: '14px' }"
                    >
                        <template #empty> No se encontraron envios. </template>
                        <Column
                            selectionMode="multiple"
                            :exportable="false"
                            style="padding: 1rem"
                        ></Column>
                        <Column header="Orden" style="min-width: 9rem">
                            <template #body="slotProps">
                                <div class="flex items-center space-x-2">
                                    <div class="flex flex-col">
                                        <div class="text-[12px]">
                                            {{
                                                slotProps.data.created_at
                                            }}
                                            <!-- {{
                                                formatDate(
                                                    slotProps.data.created_at
                                                )
                                            }} -->
                                        </div>
                                        <div v-if="slotProps.data.orden_id">
                                            {{ slotProps.data.orden_id }}
                                        </div>
                                        <div v-else>-</div>
                                    </div>

                                    <div class="flex flex-col gap-y-1">
                                        <Icon
                                            size="15"
                                            v-tooltip.top="'Etiqueta descargada'"
                                            v-if="
                                                slotProps.data.etiqueta_descargada
                                            "
                                        >
                                            <BookmarkOff24Filled 
                                                class="text-gray-600"
                                            />
                                        </Icon>
                                        <Icon
                                            v-if="
                                                slotProps.data.listo_para_recolectar
                                            "
                                            size="15"
                                            v-tooltip.top="'Listo para recolectar'"
                                        >
                                            <BoxCheckmark24Filled
                                                class="text-gray-600"
                                            />
                                        </Icon>
                                    </div>
                                </div>
                            </template>
                        </Column>
                        <Column header="Origen">
                            <template #body="slotProps">
                                {{ slotProps.data.origen_nombre }}
                            </template>
                        </Column>
                        <Column header="Destinatario">
                            <template #body="slotProps">
                                <div>
                                    {{ slotProps.data.destino_nombre }}
                                    <br />
                                    {{ slotProps.data.destion_email }}
                                </div>
                            </template>
                        </Column>
                        <Column header="Seguimiento">
                            <template #body="slotProps">
                                <TrackingColumn
                                    :shipment="slotProps.data"
                                    :proveedores="proveedores"
                                />
                            </template>
                        </Column>
                        <Column header="Costo">
                            <template #body="slotProps">
                                {{ slotProps.data.precio_factura }}
                            </template>
                        </Column>
                        <Column header="Ultimo est.">
                            <template #body="slotProps">
                                {{ slotProps.data.estado }}
                            </template>
                        </Column>
                        <Column header="Tipo">
                            <template #body="slotProps">
                                {{ slotProps.data.tipo }}
                            </template>
                        </Column>
                        <Column class="min-w-[192px]">
                            <template #body="slotProps">
                                <div class="flex flex-col space-y-2">
                                    <Link
                                        :href="
                                            '/envios/' +
                                            slotProps.data.seguimiento
                                        "
                                        class="flex items-center space-x-1"
                                    >
                                        <span class="hover:underline">
                                            Detalles
                                        </span>
                                        <Icon size="10">
                                            <AngleDoubleRight />
                                        </Icon>
                                    </Link>
                                    <div
                                        @click="
                                            downloadLabel(
                                                slotProps.data.seguimiento
                                            )
                                        "
                                        class="flex items-center space-x-1 hover:underline hover:cursor-pointer"
                                    >
                                        <span> Etiqueta </span>
                                        <Icon size="10">
                                            <Bookmark />
                                        </Icon>
                                    </div>
                                </div>
                            </template>
                        </Column>
                        <template #footer>
                            <div class="flex justify-center">
                                <CustomPaginator
                                    :paginationData="paginationData"
                                />
                            </div>
                        </template>
                    </DataTable>
                </XyzTransition>
            </div>
            <ExportDialog
                :exportDialog="exportDialog"
                :clientes="clientes"
                @dispatchNotification="dispatchNotification($event)"
                @hideDialog="hideDialog"
            />
            <OptionsDialog
                :optionsDialog="optionsDialog"
                :selectedShipping="selectedShipping"
                @discardOptions="discardOptions"
                @reloadProps="reloadProps"
                @deleteSuccess="handleDeleteSuccess"
            />
        </div>
    </AppLayout>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import axios from "axios";
import pickBy from "lodash/pickBy";
import formatDate from "../../helpers/formatDate";
import AppLayout from "@/Layouts/AppLayout.vue";
import CustomFilter from "@/Pages/Envios/components/CustomFilter.vue";
import CustomPaginator from "./components/CustomPaginator.vue";
import TrackingColumn from "./components/TrackingColumn.vue";
import ExportDialog from "./components/ExportDialog.vue";
import DeleteDialog from "./components/DeleteDialog.vue";
import OptionsDialog from "./components/OptionsDialog.vue";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";
import { Icon } from "@vicons/utils";
import {
    ArrowRight,
    Bookmark,
    AngleDoubleRight,
    FileExport,
    Plus,
} from "@vicons/fa";
import { BoxCheckmark24Filled, BookmarkOff24Filled } from "@vicons/fluent";

export default {
    components: {
        Link,
        AppLayout,
        CustomFilter,
        CustomPaginator,
        TrackingColumn,
        ExportDialog,
        DeleteDialog,
        OptionsDialog,
        Breadcrumb,
        Icon,
        ArrowRight,
        AngleDoubleRight,
        FileExport,
        Bookmark,
        Button,
        Plus,
        BoxCheckmark24Filled,
        BookmarkOff24Filled 
    },
    props: {
        proveedores: Object,
        clientes: Array,
        envios: Object,
        filtros: Object,
    },
    data() {
        return {
            shipping: [],
            shipment: null,
            selectedShipping: null,
            exportDialog: false,
            sidebarMobile: false,
            loading: false,
            loadingDownload: false,
            filtersData: {
                query: null,
                cliente: null,
                fecha_rango: null,
                estado: null,
                proveedor: null,
            },
            changeShipmentDialog: false,
            returnShipmentDialog: false,
            optionsDialog: false,
        };
    },
    computed: {
        paginationData() {
            const { data: _, ...pageData } = this.envios;
            return pageData;
        },
    },
    watch: {
        selectedShipping(newState) {
            if (newState?.length > 0) {
                this.optionsDialog = true;
            } else {
                this.optionsDialog = false;
            }
        },
    },
    created() {
        this.shipping = [...this.envios.data];
        this.updateFilters();
    },
    mounted() {
        if (this.$page.props.flash.success) {
            this.$toast.add({
                severity: "success",
                summary: "Listo!",
                detail: this.$page.props.flash.success,
                life: 5000,
            });
        }
    },
    methods: {
        formatDate,
        reloadProps() {
            Inertia.reload({
                only: ["envios"],
                onSuccess: () => {
                    this.shipping = [...this.envios.data];
                },
                onError: () =>
                    this.dispatchNotification({
                        severity: "error",
                        summary: "Ha ocurrido un error",
                        detail: "Intenta más tarde",
                        life: 3000,
                    }),
            });
        },
        openExportDialog() {
            this.exportDialog = true;
        },
        downloadLabel(seguimiento) {
            axios
                .get("envios/etiqueta/" + seguimiento, {
                    "Content-Disposition": "attachment",
                })
                .then((res) => {
                    let downloadLabel = document.createElement("a");
                    downloadLabel.href =
                        "data:application/octet-stream;base64," + res.data.etiquetas;
                    downloadLabel.download = `shipro_${seguimiento}.pdf`;
                    downloadLabel.click();
                    this.reloadProps();
                })
                .catch((err) => console.error(err));
        },
        hideDialog() {
            this.exportDialog = false;
            this.deleteDialog = false;
        },
        clearFilters() {
            this.filtersData = {
                query: null,
                cliente: null,
                fecha_rango: null,
                estado: null,
                proveedor: null,
            };
            this.getFilteredShipment();
            this.shipping = [...this.envios.data];
            this.selectedShipping = null;
        },
        dispatchNotification(options) {
            this.$toast.add(options);
        },
        getFilteredShipment() {
            this.loading = true;
            this.$inertia.get("/envios", pickBy(this.filtersData), {
                preserveState: true,
                onSuccess: () => {
                    this.shipping = [...this.envios.data];
                    this.loading = false;
                },
                onError: () => {
                    this.loading = false;
                    this.$toast.add({
                        severity: "error",
                        summary: "Ha ocurrido un error",
                        detail: "Intenta más tarde",
                        life: 3000,
                    });
                },
            });
        },
        discardOptions() {
            this.optionsDialog = false;
            this.selectedShipping = null;
        },
        handleDeleteSuccess() {
            this.discardOptions();
            this.reloadProps();
        },
        updateFilters() {
            let firstDate = null;
            let secondDate = null;
            let dateRange = [];

            if (this.filtros.fecha_rango) {
                if (this.filtros.fecha_rango.length > 0) {
                    firstDate = new Date(this.filtros.fecha_rango[0]);
                    dateRange.push(firstDate);
                }
                if (this.filtros.fecha_rango.length > 1) {
                    secondDate = new Date(this.filtros.fecha_rango[1]);
                    dateRange.push(secondDate);
                }
            }
            this.filtersData = { 
                ...this.filtros,
                fecha_rango: dateRange
            };
        }
    },
};
</script>

<style></style>
